import { render, staticRenderFns } from "./user-edit.vue?vue&type=template&id=e93efb70&"
import script from "./user-edit.ts?vue&type=script&lang=js&"
export * from "./user-edit.ts?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports